import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import classNames from "classnames";
import React, { useContext } from "react";
import { getLink, getLinkTitle } from "../components/Blocks";
import { NavigationContext } from "../contexts/NavigationContext";
import { ContactInformation } from "./ContactInformation";
import { ExternalLinkSelection } from "./ExternalLinkSelection";
import { LanguageChooser } from "./LanguageChooser";
import { NavigationToggleButton } from "./NavigationToggleButton";

export const NavigationDrawerDesktop: React.FC<{
  corePath: string;
  logo?: IGatsbySvg;
  navigation: Queries.MainNavigationFragment;
}> = (props) => {
  const { toggleNavigation } = useContext(NavigationContext);
  const {
    corePath,
    navigation: { contactInformation, pageLinks, externalLinkSelection },
  } = props;
  const { isNavigationOpen, closeNavigation } = useContext(NavigationContext);
  const navStateClasses = isNavigationOpen
    ? "translate-x-0"
    : "translate-x-10/10";

  return (
    <>
      <div
        data-component="Navigation drawer desktop"
        className={classNames(
          "fixed",
          "w-full",
          "h-full",
          "left-0",
          "top-0",
          "z-40",
          "overflow-y-auto",
          "transition",
          "transform",
          navStateClasses,
        )}
      >
        <div
          className={classNames(
            "bg-gradient-to-l from-hyacinth",
            "w-full",
            "h-full",
            "top-0",
            "left-0",
            "absolute",
            "z-10",
          )}
          onClick={toggleNavigation}
          onKeyDown={toggleNavigation}
          role="button"
          aria-label="Toggle navigation"
          tabIndex={0}
        ></div>
        <div className="page-grid pointer-events-none relative z-50 h-full h-full overflow-x-hidden">
          <div className="pointer-events-auto col-span-11 col-start-6 h-full overflow-y-scroll bg-hyacinth">
            <div className="grid h-full grid-cols-12 items-center gap-0">
              <NavigationToggleButton className="col-span-1 col-start-1 ml-auto" />
              <ul
                className={classNames(
                  "text-cotton",
                  "col-span-6",
                  "col-start-3",
                  "py-48px",
                  "row-span-1 row-start-1",
                )}
              >
                {pageLinks?.map((pageLink, i) => {
                  return (
                    <li key={i} className={classNames("h2", "mb-30px")}>
                      <Link to={getLink(pageLink)} onClick={closeNavigation}>
                        {getLinkTitle(pageLink)}
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <div className="dashed-line-y col-span-1 col-start-7 row-span-1 row-start-1 mx-60px block h-full justify-self-center text-cotton"></div>
              <div
                className={classNames(
                  "col-start-8",
                  "col-span-4",
                  "row-span-1 row-start-1 py-48px",
                )}
              >
                {contactInformation && (
                  <ContactInformation
                    information={contactInformation}
                    className="mb-50px"
                  />
                )}
                {externalLinkSelection && (
                  <ExternalLinkSelection
                    onClick={closeNavigation}
                    links={externalLinkSelection.externalLinks}
                  />
                )}
                <LanguageChooser
                  corePath={corePath}
                  onClick={closeNavigation}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
